import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const GiftIcon: FunctionComponent<Props> = ({
  className = "",
  width = 16,
  height = 16,
  fill = "#fff",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <title>Gift</title>
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#a)"
      >
        <path
          fill={fill}
          d="M13.47 8v6.427a.41.41 0 0 1-.41.41H2.94a.41.41 0 0 1-.41-.41V8M14.427 4.582H1.573a.41.41 0 0 0-.41.41V7.59c0 .227.184.41.41.41h12.854a.41.41 0 0 0 .41-.41V4.992a.41.41 0 0 0-.41-.41ZM8 14.837V4.582"
        />
        <path
          fill={fill}
          d="M8 4.581H4.923a1.71 1.71 0 1 1 0-3.418C7.316 1.163 8 4.58 8 4.58ZM8 4.581h3.077a1.71 1.71 0 1 0 0-3.418C8.684 1.163 8 4.58 8 4.58Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GiftIcon;
